import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EventWebsiteDesignQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type EventWebsiteDesignQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      artBackgroundColor?: string | null;
      artFontColor?: string | null;
      pageBackgroundColor?: string | null;
      pageFontColor?: string | null;
      linkAndButtonColor?: string | null;
      brannanNavigation: Types.BrannanNavigation;
      theme: { __typename?: 'Theme'; id: string; themeId: string };
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType };
      fonts?: Array<{ __typename?: 'FontPackConfiguration'; id: string; category: Types.Category; font?: { __typename?: 'Font'; id: string; fontFamily: string } | null }> | null;
      font: { __typename?: 'Font'; id: string; fontFamily: string; textTransform: Types.FontWeight };
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; schemaURL: string; websiteLayout: string; dataJSON: any; id: string } | null;
    } | null;
  } | null;
};

export type EventWebsiteDesignV2SitesQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type EventWebsiteDesignV2SitesQuery = {
  __typename?: 'Query';
  carbonWebsiteSitesByEventId: Array<{
    __typename?: 'CarbonWebsiteSite';
    id: string;
    legacyDesign?: {
      __typename?: 'CarbonWebsiteLegacyDesign';
      themeId?: string | null;
      layoutType?: string | null;
      titleFont?: string | null;
      headerPresentationLayout?: string | null;
      brannanNavigation?: string | null;
      colors?: { __typename?: 'CarbonWebsiteV1PresetColors'; artBackground: string; artFont: string; pageBackground: string; pageFont: string; linkAndButton: string } | null;
      fonts: Array<{ __typename?: 'CarbonWebsiteLegacyFont'; category: string; fontFamily: string; sizePercent: number }>;
    } | null;
    heroPhotos: Array<{ __typename?: 'CarbonWebsiteSectionPhoto'; url?: string | null; placeholder: boolean }>;
  }>;
};

export const EventWebsiteDesignDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventWebsiteDesign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'EnumValue', value: 'live' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'theme' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fonts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'font' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'textTransform' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventWebsiteDesignQuery__
 *
 * To run a query within a React component, call `useEventWebsiteDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsiteDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsiteDesignQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventWebsiteDesignQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsiteDesignQuery, EventWebsiteDesignQueryVariables>) {
  return ApolloReactHooks.useQuery<EventWebsiteDesignQuery, EventWebsiteDesignQueryVariables>(EventWebsiteDesignDocument, baseOptions);
}
export function useEventWebsiteDesignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsiteDesignQuery, EventWebsiteDesignQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EventWebsiteDesignQuery, EventWebsiteDesignQueryVariables>(EventWebsiteDesignDocument, baseOptions);
}
export type EventWebsiteDesignQueryHookResult = ReturnType<typeof useEventWebsiteDesignQuery>;
export type EventWebsiteDesignLazyQueryHookResult = ReturnType<typeof useEventWebsiteDesignLazyQuery>;
export type EventWebsiteDesignQueryResult = Apollo.QueryResult<EventWebsiteDesignQuery, EventWebsiteDesignQueryVariables>;
export const EventWebsiteDesignV2SitesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventWebsiteDesignV2Sites' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteSitesByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'legacyDesign' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'artBackground' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'artFont' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageBackground' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageFont' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'linkAndButton' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleFont' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fonts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sizePercent' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'headerPresentationLayout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroPhotos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventWebsiteDesignV2SitesQuery__
 *
 * To run a query within a React component, call `useEventWebsiteDesignV2SitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsiteDesignV2SitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsiteDesignV2SitesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventWebsiteDesignV2SitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsiteDesignV2SitesQuery, EventWebsiteDesignV2SitesQueryVariables>) {
  return ApolloReactHooks.useQuery<EventWebsiteDesignV2SitesQuery, EventWebsiteDesignV2SitesQueryVariables>(EventWebsiteDesignV2SitesDocument, baseOptions);
}
export function useEventWebsiteDesignV2SitesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsiteDesignV2SitesQuery, EventWebsiteDesignV2SitesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<EventWebsiteDesignV2SitesQuery, EventWebsiteDesignV2SitesQueryVariables>(EventWebsiteDesignV2SitesDocument, baseOptions);
}
export type EventWebsiteDesignV2SitesQueryHookResult = ReturnType<typeof useEventWebsiteDesignV2SitesQuery>;
export type EventWebsiteDesignV2SitesLazyQueryHookResult = ReturnType<typeof useEventWebsiteDesignV2SitesLazyQuery>;
export type EventWebsiteDesignV2SitesQueryResult = Apollo.QueryResult<EventWebsiteDesignV2SitesQuery, EventWebsiteDesignV2SitesQueryVariables>;
